import { doMagic, clearCanvas, getCanvasData, isCanvasEmpty } from './../../../vehicle/vehicleAppraisal/bodywork/canvasStuff';

class SimpleDpaController {
  constructor($state, $stateParams, loadingService, contactService, authService) {
    "ngInject";

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loadingService = loadingService;
    this.contactService = contactService;
    this.authService = authService;

    if (!$stateParams.contactId || !$stateParams.enquiryId){
      $state.go('welcomeCentre');
    }

    this.dpa = $stateParams.dpa;
    
    this.errUpdateDpa = '';

    //this.preventTabletScroll();
    window.setTimeout(this.editImage, 10);    
  }

  goBack() {
    this.$state.go('enquiryEdit', {enquiryId: this.$stateParams.enquiryId});
  }

  editImage() {
    const $container = $('.signature-container');
    const width = $container.width();
    const height = $container.height();
  
    const $divCanvas = $(`<div idx="imageHolder" style="width:${width}px;height:${height}px;background: url(''); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="${width}px" height="${height}px" id="sig-canvas"></canvas><canvas width="${width}px" height="${height}px" style="display:none;" id="hidden-canvas"></canvas></div>`);
    $('.signature-container').empty().append($divCanvas);
    doMagic(null, true);
  }  

  clearSignature() {
    clearCanvas(true);    
  }
  
  confirmVerbalConsent() {
    if (this.dpa.verbalConsent){
      this.dpa.verbalConsent = window.confirm('By clicking this checkbox, you will have to sign the DPA on behalf of the customer. Are you sure you want to proceed ?');      
    }    
  }
  
  checkOptions(val) {
    this.dpa.viaEmail = val;
    this.dpa.viaText = val;
    this.dpa.viaPost = val;
    this.dpa.viaPhone = val;
  }  

  updateDpa() {
    const ctrl = this;

    if (!ctrl.validateDpa()) { return; }

    ctrl.loadingService.showLoading('dpa', 'Updating DPA ...');

    ctrl.dpa.signData = getCanvasData();
    ctrl.contactService.updateDpa(ctrl.authService.authData.currentLocation.key, ctrl.dpa)
      .then(response => {
        ctrl.loadingService.hideLoading('dpa');
        ctrl.goBack();
      });
  }
  
  validateDpa() {
    this.errUpdateDpa = '';

    if (isCanvasEmpty()) {
      this.errUpdateDpa = 'Please sign the form before submitting';
      return false;
    }

    return true;
  }  
}

export default SimpleDpaController;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/simpleDpa/simpleDpa.controller.js